import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    jobList,
    jobDelete,
    createJob,
    editJob,
    jobListById,
    jobStatusUpdate,
    userJobs,
    getuserJobsEvents,
    userDataJobs,
    allocateDataToUsers,
    eventDataInJobs,
    uploadLogsData,
    allocateJobDataById,
    uploadExcelData,
    JobEventUpdate,
    addJobEvents,
    jobEventDelete,
    JobBarocdeStausUpdate,
    JobBarcodeReassignSpec,
    JobEventsReWork,
    reAllocateDataToUsers,
    getuserCompletedJobsEvents,
    JobEventHistory,
    getAdminJobsEvents,
    JobDashBoard,
    getAdminJobsEventsDetails,
    getCompletedAdminJobsEventsDetails,
    getreWorkEventDetails,
    getAllEventsAssignData,
    JobBarcodeDashBoard,
    EventStagesHistory,
    AllBoxesBarocde,
    jobInspectionReport,
    EventBoxesBarocde

} from "../../services/api";
import { secretKey } from "../../services/config";
import EncryptDecrypt from "../../utils/encrypt&decrypt";
import alertmessage from "../../utils/alert";
import { act } from "react";

const namespace = "jobs";

// Async thunk for fetching the Portal customer list
export const getJobsList = createAsyncThunk(
    `${namespace}/getJobsList`,
    async (
        { query = "", page = 0, limit = 0, sortby = "", order = "", status },
        { rejectWithValue }
    ) => {
        try {
            const data = await jobList(query, page, limit, sortby, order, status);
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

//users job list 
export const getUsersJobsList = createAsyncThunk(
    `${namespace}/getUsersJobsList`,
    async (userId, { rejectWithValue }) => {
        try {
            const data = await userJobs(userId);
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
// Async thunk for fetching the Portal Job by id
export const getJobByID = createAsyncThunk(
    `${namespace}/getJobByID`,
    async ({ editId }, { rejectWithValue }) => {
        try {
            const data = await jobListById({ editId });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for updating Portal users data in job module for allocate data
export const allocateJobUsers = createAsyncThunk(
    `${namespace}/allocateJob`,
    async ({ jobId, event_id }, { rejectWithValue }) => {
        try {
            const data = await userDataJobs({ payload: jobId, event_id });
            const decryptedData = JSON.parse(
                EncryptDecrypt.decryptdata(data.data.datas, secretKey)
            );
            return { datas: decryptedData };
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const jobAllocationById = createAsyncThunk(
    `${namespace}/jobAllocationById`,
    async (
        { editId, event_id },

        { rejectWithValue }
    ) => {
        try {
            const data = await allocateJobDataById({ editId, event_id });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

//events data in shoing in job module
export const getEventDataInJobs = createAsyncThunk(
    `${namespace}/getEventDataInJobs`,
    async ({ jobId }, { rejectWithValue }) => {
        try {
            const data = await eventDataInJobs({ jobId });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);


// craete data allocating in admin module 

export const addDataAllocation = createAsyncThunk(
    `${namespace}/addDataAllocation`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await allocateDataToUsers({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const addDataReAllocation = createAsyncThunk(
    `${namespace}/addDataAllocation`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await reAllocateDataToUsers({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for adding a Portal customer
export const addJob = createAsyncThunk(
    `${namespace}/addJob`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await createJob({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for updating Portal Customer data
export const updateJob = createAsyncThunk(
    `${namespace}/updateJob`,
    async ({ postData, updateID }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await editJob({ payload }, updateID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for deleting a Portal User group
export const deleteJob = createAsyncThunk(
    `${namespace}/deleteJob`,
    async ({ deleteID }, { rejectWithValue }) => {
        try {
            const data = await jobDelete(deleteID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const updateJobStatus = createAsyncThunk(
    `${namespace}/UpdateStatus`,
    async ({ postData, updateID }, { rejectWithValue }) => {
        try {
            let payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await jobStatusUpdate({ payload }, updateID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const addJobEvent = createAsyncThunk(
    `${namespace}/addJobEvent`,
    async ({ updateID, postData }, { rejectWithValue }) => {
        try {
            let payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await addJobEvents(updateID, { payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const deleteJobEvent = createAsyncThunk(
    `${namespace}/deleteJobEvent`,
    async ({ updateID }, { rejectWithValue }) => {
        try {
            const data = await jobEventDelete(updateID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const usersJobEvent = createAsyncThunk(
    `${namespace}/UsersJobEvent`,
    async ({ jobId, userId, event_id, page = 0, limit = 0, query, nextClick }, { rejectWithValue }) => {
        try {
            if (query && query.trim() !== '' || nextClick) {

                const data = await getuserJobsEvents({ jobId, userId, event_id, page, limit, query });
                const eventFieldNames = JSON.parse(
                    EncryptDecrypt.decryptdata(data?.data?.eventFieldNames, secretKey)
                );
                const eventFieldValidations = JSON.parse(
                    EncryptDecrypt.decryptdata(data?.data?.eventFieldValidations, secretKey)
                );
                const resultData = JSON.parse(
                    EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
                );
                const count = JSON.parse(
                    EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
                );
                const totlaCount = count?.count
                return { eventFieldNames, eventFieldValidations, resultData, totlaCount, nextEventId: data?.data?.nextEventId, previousUserEventId: data?.data?.previousUserEventId };
            }
            // const data = await getuserJobsEvents({ jobId, userId, event_id, page, limit, query });

        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const adminJobEvent = createAsyncThunk(
    `${namespace}/adminJobEvent`,
    async ({ jobId, userId, event_id, page = 0, limit = 0, query, nextClick }, { rejectWithValue }) => {
        try {
            if (query && query.trim() !== '' || nextClick) {
                const data = await getAdminJobsEvents({ jobId, userId, event_id, page, limit, query });
                const eventFieldNames = JSON.parse(
                    EncryptDecrypt.decryptdata(data?.data?.eventFieldNames, secretKey)
                );
                const eventFieldValidations = JSON.parse(
                    EncryptDecrypt.decryptdata(data?.data?.eventFieldValidations, secretKey)
                );
                const resultData = JSON.parse(
                    EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
                );
                const count = JSON.parse(
                    EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
                );
                const totlaCount = count?.count
                return { eventFieldNames, eventFieldValidations, resultData, totlaCount, nextEventId: data?.data?.nextEventId, previousUserEventId: data?.data?.previousUserEventId };
            }
            // const data = await getuserJobsEvents({ jobId, userId, event_id, page, limit, query });

        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const adminJobEventDetails = createAsyncThunk(
    `${namespace}/adminJobEventDetails`,
    async ({ jobId, event_id, workflow_id, page = 0, limit = 0, dashboardType, query }, { rejectWithValue }) => {
        try {

            const data = await getAdminJobsEventsDetails({ jobId, event_id, page, limit, workflow_id, dashboardType, query });
            const eventFieldNames = JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.eventFieldNames, secretKey)
            );
            const eventFieldValidations = JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.eventFieldValidations, secretKey)
            );
            const resultData = JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
            const count = JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
            const totlaCount = count?.count
            return { eventFieldNames, eventFieldValidations, resultData, totlaCount, };

            // const data = await getuserJobsEvents({ jobId, userId, event_id, page, limit, query });

        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const reworkEventsData = createAsyncThunk(
    `${namespace}/reworkEventsData`,
    async ({ jobId, event_id, workflow_id, page = 0, limit = 0, query, role_id, user_id, }, { rejectWithValue }) => {
        try {
            const data = await getreWorkEventDetails({ jobId, event_id, page, limit, workflow_id, query, role_id, user_id, });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );

            // const data = await getuserJobsEvents({ jobId, userId, event_id, page, limit, query });

        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const allkEventsData = createAsyncThunk(
    `${namespace}/allkEventsData`,
    async ({ jobId, event_id, page = 0, limit = 0, query, role_id, user_id, barcode }, { rejectWithValue }) => {
        try {

            const data = await getAllEventsAssignData({ jobId, event_id, page, limit, query, role_id, user_id, barcode });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );

            // const data = await getuserJobsEvents({ jobId, userId, event_id, page, limit, query });

        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const completedAdminJobEventDetails = createAsyncThunk(
    `${namespace}/completedAdminJobEventDetails`,
    async ({ jobId, userId, event_id, page = 0, limit = 0, query, nextClick, workflow_id }, { rejectWithValue }) => {
        try {
            const data = await getCompletedAdminJobsEventsDetails({ jobId, userId, event_id, page, limit, workflow_id, query });
            const eventFieldNames = JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.eventFieldNames, secretKey)
            );
            const eventFieldValidations = JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.eventFieldValidations, secretKey)
            );
            const resultData = JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
            const count = JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
            const totlaCount = count?.count
            return { eventFieldNames, eventFieldValidations, resultData, totlaCount, nextEventId: data?.data?.nextEventId, previousUserEventId: data?.data?.previousUserEventId };

            // const data = await getuserJobsEvents({ jobId, userId, event_id, page, limit, query });

        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const usersCompletedJobEvent = createAsyncThunk(
    `${namespace}/usersCompletedJobEvent`,
    async ({ jobId, userId, event_id, page = 0, limit = 0, query, nextClick }, { rejectWithValue }) => {
        try {
            if (query && query.trim() !== '' || nextClick) {
                const data = await getCompletedAdminJobsEventsDetails({ jobId, userId, event_id, page, limit, query });
                const eventFieldNames = JSON.parse(
                    EncryptDecrypt.decryptdata(data?.data?.eventFieldNames, secretKey)
                );
                const eventFieldValidations = JSON.parse(
                    EncryptDecrypt.decryptdata(data?.data?.eventFieldValidations, secretKey)
                );
                const resultData = JSON.parse(
                    EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
                );
                const count = JSON.parse(
                    EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
                );
                const totlaCount = count?.count
                return { eventFieldNames, eventFieldValidations, resultData, totlaCount, nextEventId: data?.data?.nextEventId, previousUserEventId: data?.data?.previousUserEventId };
            }
            // const data = await getuserJobsEvents({ jobId, userId, event_id, page, limit, query });

        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const usersJobEventUploadLog = createAsyncThunk(
    `${namespace}/usersJobEventUploadLog`,
    async ({ userId }, { rejectWithValue }) => {
        try {
            const data = await uploadLogsData({ userId });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
)
export const uploadDataEntryExcel = createAsyncThunk(
    `${namespace}/uploadDataEntryExcel`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await uploadExcelData({ payload: { payload } });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
)

export const UpdateJobEVent = createAsyncThunk(
    `${namespace}/UpdateJobEVent`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await JobEventUpdate({ payload: { payload } });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
)
export const UpdateJobBarocde = createAsyncThunk(
    `${namespace}/UpdateJobBarocde`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await JobBarocdeStausUpdate({ payload: { payload } });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
)

export const UpdateReWorkEvents = createAsyncThunk(
    `${namespace}/UpdateReWorkEvents`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await JobEventsReWork({ payload: { payload } });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
)

export const reassignSpecJobBarocde = createAsyncThunk(
    `${namespace}/reassignSpecJobBarocde`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await JobBarcodeReassignSpec({ payload: { payload } });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
)

export const getJobEventsHistory = createAsyncThunk(
    `${namespace}/getJobEventsHistory`,
    async ({ query = "", page = 0, limit = 0, sortby = "", order = "", barcode, event_id }, { rejectWithValue }) => {
        try {
            const data = await JobEventHistory({ query, page, limit, sortby, order, barcode, event_id });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const getEventStagesHistory = createAsyncThunk(
    `${namespace}/getEventStagesHistory`,
    async ({ query = "", page = 0, limit = 0, sortby = "", order = "", barcode }, { rejectWithValue }) => {
        try {
            const data = await EventStagesHistory({ query, page, limit, sortby, order, barcode });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

//get all box data in box processing
export const getAllBoxes = createAsyncThunk(
    `${namespace}/getAllBoxes`,
    async ({ query = "", page = 0, limit = 0, sortby = "", order = "", pickup_date, spec_id, box_status, job_spec_id, stage }, { rejectWithValue }) => {
        try {
            const data = await AllBoxesBarocde({ query, page, limit, sortby, order, pickup_date, spec_id, box_status, job_spec_id, stage });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const getEventBoxes = createAsyncThunk(
    `${namespace}/getEventBoxes`,
    async ({ query = "", page = 0, limit = 0, sortby = "", order = "", pickup_date, event_id, box_status }, { rejectWithValue }) => {
        try {
            const data = await EventBoxesBarocde({ query, page, limit, sortby, order, pickup_date, event_id, box_status });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const getJobDashBoard = createAsyncThunk(
    `${namespace}/getJobDashBoard`,
    async (id, { rejectWithValue }) => {
        try {
            const data = await JobDashBoard(id);
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const getJobBarcodeDashBoard = createAsyncThunk(
    `${namespace}/getJobBarcodeDashBoard`,
    async ({ id, query = "", page = 0, limit = 0, sortby = "", order = "" },
        { rejectWithValue }) => {
        try {
            const data = await JobBarcodeDashBoard({ id, query, page, limit, sortby, order });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const getJobInspectionReport = createAsyncThunk(
    `${namespace}/getJobInspectionReport`,
    async (
        { query = "", page = 0, limit = 0, sortby = "", order = "" },
        { rejectWithValue }
    ) => {
        try {
            const data = await jobInspectionReport(query, page, limit, sortby, order);
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);


// User Group Slice
const jobSlice = createSlice({
    name: namespace,
    initialState: {
        jobLoading: false,
        jobListData: [], // Ensure this structure matches the expected format
        jobListError: false,
        jobListErrorMessage: "",
        userJosData: [], // Ensure this structure matches the expected formatting
        adminJobEventSuccess: false,
        adminJobEventError: false,
        jobListByIdData: [],
        jobListByIdError: false,
        addJobSuccess: false,
        addJobError: false,
        addJobErrorMessage: "",
        updateJobSuccess: false,
        updateJobError: false,
        updateJobErrorMessage: "",
        deleteJobSuccess: false,
        deleteJobError: false,
        deleteJobErrorMessage: "",
        jobStatusSuccess: false,
        jobStatusError: false,
        jobStatusErrorMessage: "",
        userJobEventData: [],
        userCompletedData: [],
        adminJobEventData: [],
        adminJobEventDetailsData: [],
        completedAdminJobEventDetailsData: [],
        adminobEventsDetailsDataError: false,
        adminJobEventsDetailsDataErrorMessage: "",
        adminobEventsDataError: false,
        adminJobEventsDataErrorMessage: "",
        userJobEventHistoryData: [],
        eventStagesHistoryData: [],
        userJobEventsDataError: false,
        userJobEventsDataErrorMessage: "",
        userDataINJObs: [],
        addDataAllocationSuccess: false,
        addDataAllocationError: false,
        addDataAllocationErrorMessage: "",
        getEventDataInJobsResponse: [],
        uploadLogsData: [],
        allocateJobByIdData: [],
        uploadExcelDataSuccess: false,
        uploadExcelDataError: false,
        uploadExcelDataErrorMessage: "",
        jobEventUpdateSuccess: false,
        jobEventUpdateError: false,
        jobEventUpdateErrorMessage: "",
        addJobEventsSuccess: false,
        addJobEventsError: false,
        addJobEventsErrorMessage: "",
        jobEventDeleteSuccess: false,
        jobEventDeleteError: false,
        jobEventDeleteErrorMessage: "",
        jobBarcodeSatusSuccess: false,
        jobBarcodeSatusError: false,
        jobBarcodeSatusErrorMessage: "",
        jobBarcodrReassignSuccess: false,
        jobBarcodeReassignError: false,
        jobBarcodeSReassignErrorMessage: "",
        jobEventsReworkSuccess: false,
        jobEventsReworkError: false,
        jobEventsReworkErrorMessage: "",
        getJobDashBoardData: [],
        getJobBarcodeDashBoardData: [],
        reworkEventsDatas: [],
        getAllSpecificEventsAssignData: [],
        getAllBoxesData: [],
        getJobInspectionReportData: [],
        getEventBoxesData: []
    },

    reducers: {
        resetAllocationData: (state) => {
            state.allocateJobByIdData = [];
        },
        resetSuccessFlag: (state, action) => {
            const { flag } = action.payload;
            state[flag] = false;
        },
        clearUserJobEventData: (state) => {
            state.userJobEventData = [];
        },
        clearUserCompletedData: (state) => {
            state.userCompletedData = [];
        },
        clearAdminJobEventData: (state) => {
            state.adminJobEventData = [];
        }

    },

    extraReducers: (builder) => {
        builder
            // Handle getUserGroupList
            .addCase(getJobsList.pending, (state) => {
                state.jobLoading = true;
            })
            .addCase(getJobsList.fulfilled, (state, action) => {

                const data = action.payload;
                state.jobListData = data;
                state.addJobSuccess = false;
                state.jobEventUpdateSuccess = false;
                state.jobLoading = false;
            })

            .addCase(getJobsList.rejected, (state, action) => {
                state.jobLoading = false;
                if (action?.payload?.data?.auth === "deleted") {
                    alertmessage.sweetalert(action?.payload?.data?.message);
                }

            })
            .addCase(getUsersJobsList.pending, (state) => {
                state.jobLoading = true;
            })
            .addCase(getUsersJobsList.fulfilled, (state, action) => {
                const data = action.payload;
                state.userJosData = data;
                state.jobLoading = false;
            })
            .addCase(getUsersJobsList.rejected, (state, action) => {
                state.jobLoading = false;
                if (action?.payload?.data?.auth === "deleted") {
                    alertmessage.sweetalert(action?.payload?.data?.message);
                }
            })

            .addCase(getJobByID.pending, (state) => {
                state.jobLoading = true;
            })
            .addCase(getJobByID.fulfilled, (state, action) => {
                const data = action.payload;
                state.jobListByIdData = data;
                state.jobLoading = false;
            })
            .addCase(getJobByID.rejected, (state, action) => {
                state.jobLoading = false;
                if (action?.payload?.data?.auth === "deleted") {
                    alertmessage.sweetalert(action?.payload?.data?.message);
                }
            })
            .addCase(addJob.pending, (state) => {
                state.jobLoading = true;
                state.addJobError = false;
                state.addJobSuccess = false;
            })
            .addCase(addJob.fulfilled, (state) => {
                state.jobLoading = false;
                state.addJobSuccess = true;


            })
            .addCase(addJob.rejected, (state, action) => {
                state.jobLoading = false;
                state.addJobError = true;

                state.addJobErrorMessage =
                    action.payload?.data?.message || "An error occurred";
            })

            // Handle updateUserGroup
            .addCase(updateJob.pending, (state) => {
                state.jobLoading = false;
                state.updateJobError = false;
                state.updateJobErrorMessage = "";
            })
            .addCase(updateJob.fulfilled, (state) => {
                state.updateJobSuccess = true;
            })
            .addCase(updateJob.rejected, (state, action) => {
                state.updateJobError = true;
                state.updateJobErrorMessage =
                    action.payload?.data?.message || "An error occurred";
            })

            // Handle deleteUserGroup
            .addCase(deleteJob.pending, (state) => {
                state.jobLoading = true;
                state.deleteJobError = false;
                state.deleteJobErrorMessage = false;
            })
            .addCase(deleteJob.fulfilled, (state) => {
                state.jobLoading = false;
                state.deleteJobSuccess = true;
            })
            .addCase(deleteJob.rejected, (state, action) => {
                state.jobLoading = false;
                state.deleteJobError = true;
                state.deleteJobErrorMessage =
                    action.payload?.data?.message || "An error occurred";
            })
            .addCase(updateJobStatus.pending, (state, action) => {
                state.jobLoading = true;
                state.jobStatusError = false;
                state.jobStatusErrorMessage = "";

            })
            .addCase(updateJobStatus.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.jobStatusSuccess = true;
            })
            .addCase(updateJobStatus.rejected, (state, action) => {
                state.jobLoading = false;
                state.jobStatusError = true;
                state.jobStatusErrorMessage =
                    action.payload?.data?.message || "An error occurred";
            })
            .addCase(usersJobEvent.pending, (state) => {
                state.jobLoading = true;
            })
            .addCase(usersJobEvent.fulfilled, (state, action) => {
                state.jobLoading = false
                state.jobEventUpdateSuccess = false
                state.jobBarcodeSatusSuccess = false
                state.userJobEventData = { ...action.payload };  // Ensure new reference
                state.userJobEventsDataError = false
                state.userCompletedData = []

            })
            .addCase(usersJobEvent.rejected, (state, action) => {
                state.jobLoading = false;
                state.userJobEventsDataError = true;
                state.userJobEventsDataErrorMessage = action.payload.data.message
            })
            .addCase(allocateJobUsers.pending, (state, action) => {
                state.jobLoading = true;
            })
            .addCase(allocateJobUsers.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.userDataINJObs = action.payload;
            })
            .addCase(allocateJobUsers.rejected, (state, action) => {
                state.jobLoading = false;
            })
            .addCase(addDataAllocation.pending, (state, action) => {
                state.jobLoading = true;
            })
            .addCase(addDataAllocation.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.addDataAllocationSuccess = true;
            })
            .addCase(addDataAllocation.rejected, (state, action) => {
                state.jobLoading = false;
                state.addDataAllocationError = true;
            })
            .addCase(getEventDataInJobs.pending, (state, action) => {
                state.jobLoading = true;
            })
            .addCase(getEventDataInJobs.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.getEventDataInJobsResponse = action.payload;
            })
            .addCase(getEventDataInJobs.rejected, (state, action) => {
                state.jobLoading = false;
            })
            .addCase(usersJobEventUploadLog.pending, (state, action) => {
                state.jobLoading = true;
            })
            .addCase(usersJobEventUploadLog.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.uploadLogsData = action.payload;
            })
            .addCase(usersJobEventUploadLog.rejected, (state, action) => {
                state.jobLoading = false;
            })
            .addCase(jobAllocationById.pending, (state, action) => {
                state.jobLoading = true;
            })
            .addCase(jobAllocationById.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.allocateJobByIdData = action.payload;
            })
            .addCase(jobAllocationById.rejected, (state, action) => {
                state.jobLoading = false;
            })
            .addCase(uploadDataEntryExcel.pending, (state, action) => {
                state.jobLoading = true;
            })
            .addCase(uploadDataEntryExcel.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.uploadExcelDataSuccess = true;
            })
            .addCase(uploadDataEntryExcel.rejected, (state, action) => {
                state.jobLoading = false;
                state.uploadExcelDataError = true;
            })
            .addCase(UpdateJobEVent.pending, (state, action) => {
                state.jobLoading = true;
                state.jobEventUpdateError = false;
                state.jobEventUpdateSuccess = false;
            })
            .addCase(UpdateJobEVent.fulfilled, (state) => {
                state.jobLoading = false;
                state.jobEventUpdateSuccess = true;
            })
            .addCase(UpdateJobEVent.rejected, (state, action) => {
                state.jobLoading = false;
                state.jobEventUpdateError = true;
            })
            .addCase(addJobEvent.pending, (state, action) => {
                state.jobLoading = true;
            })
            .addCase(addJobEvent.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.addJobEventsSuccess = true;
            })
            .addCase(addJobEvent.rejected, (state, action) => {
                state.jobLoading = false;
                state.addJobEventsError = true;

            })
            .addCase(deleteJobEvent.pending, (state, action) => {
                state.jobLoading = true;
            })
            .addCase(deleteJobEvent.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.deleteJobSuccess = true;
            })
            .addCase(deleteJobEvent.rejected, (state, action) => {
                state.jobLoading = false;
                state.deleteJobError = true;
            })
            .addCase(UpdateJobBarocde.pending, (state, actiom) => {
                state.jobLoading = true;
            })
            .addCase(UpdateJobBarocde.fulfilled, (state, action) => {
                state.jobLoading = false
                state.jobBarcodeSatusSuccess = true
            })
            .addCase(UpdateJobBarocde.rejected, (state, action) => {
                state.jobLoading = false
                state.jobBarcodeSatusError = true
            })
            .addCase(reassignSpecJobBarocde.pending, (state, action) => {
                state.jobLoading = true
                state.jobBarcodrReassignSuccess = false
            })
            .addCase(reassignSpecJobBarocde.fulfilled, (state, action) => {
                state.jobLoading = false
                state.jobBarcodrReassignSuccess = true
            })
            .addCase(reassignSpecJobBarocde.rejected, (state, action) => {
                state.jobLoading = false
                state.jobBarcodeReassignError = true
            })
            .addCase(UpdateReWorkEvents.pending, (state, action) => {
                state.jobLoading = true
            })
            .addCase(UpdateReWorkEvents.fulfilled, (state, action) => {
                state.jobLoading = false
                state.jobEventsReworkSuccess = true
            })
            .addCase(UpdateReWorkEvents.rejected, (state, action) => {
                state.jobLoading = false
                state.jobEventsReworkError = true
            })
            .addCase(usersCompletedJobEvent.pending, (state, action) => {
                state.jobLoading = true
            })
            .addCase(usersCompletedJobEvent.fulfilled, (state, action) => {
                state.userCompletedData = { ...action.payload };
                state.userJobEventData = []
                state.jobLoading = false

            })
            .addCase(usersCompletedJobEvent.rejected, (state, action) => {
                state.jobLoading = false
            })
            .addCase(getJobEventsHistory.pending, (state, action) => {
                state.jobLoading = true
            })
            .addCase(getJobEventsHistory.fulfilled, (state, action) => {
                state.jobLoading = false
                state.userJobEventHistoryData = action.payload
            })
            .addCase(getJobEventsHistory.rejected, (state, action) => {
                state.jobLoading = false
            })
            .addCase(adminJobEvent.pending, (state, action) => {
                state.jobLoading = true;
                state.adminJobEventError = false;
            })
            .addCase(adminJobEvent.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.jobBarcodeSatusSuccess = false
                state.jobEventUpdateSuccess = false
                state.adminJobEventData = action.payload;
            })
            .addCase(adminJobEvent.rejected, (state, action) => {
                state.jobLoading = false;
                state.adminJobEventError = true;
                state.adminJobEventsDataErrorMessage = action.payload.data.message;
            })
            .addCase(getJobDashBoard.pending, (state, action) => {
                state.jobLoading = true;
                state.jobDashBoardError = false;
            })
            .addCase(getJobDashBoard.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.getJobDashBoardData = action.payload;
            })
            .addCase(getJobDashBoard.rejected, (state, action) => {
                state.jobLoading = false;
                // state.jobDashBoardError = true;
            })
            .addCase(adminJobEventDetails.pending, (state, action) => {
                state.jobLoading = true;

            })
            .addCase(adminJobEventDetails.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.adminJobEventDetailsData = action.payload;
                state.adminobEventsDetailsDataError = false
            })
            .addCase(adminJobEventDetails.rejected, (state, action) => {
                state.jobLoading = false;
                state.adminobEventsDetailsDataError = true
                state.adminJobEventsDetailsDataErrorMessage = action.payload.data.message
            })
            .addCase(completedAdminJobEventDetails.pending, (state, action) => {
                state.jobLoading = true;
            })
            .addCase(completedAdminJobEventDetails.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.completedAdminJobEventDetailsData = action.payload;
            })
            .addCase(completedAdminJobEventDetails.rejected, (state, action) => {
                state.jobLoading = false;
            })
            .addCase(reworkEventsData.pending, (state, action) => {
                state.jobLoading = true;
            })
            .addCase(reworkEventsData.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.reworkEventsDatas = action.payload;
            })
            .addCase(reworkEventsData.rejected, (state, action) => {
                state.jobLoading = false;
            })
            .addCase(allkEventsData.pending, (state, action) => {
                state.jobLoading = true;
            })
            .addCase(allkEventsData.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.getAllSpecificEventsAssignData = action.payload;
            }).addCase(allkEventsData.rejected, (state, action) => {
                state.jobLoading = false;
            }).addCase(getJobBarcodeDashBoard.pending, (state, action) => {
                state.jobLoading = true;
                state.jobBarcodeDashBoardError = false;
            })
            .addCase(getJobBarcodeDashBoard.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.getJobBarcodeDashBoardData = action.payload;
            })
            .addCase(getJobBarcodeDashBoard.rejected, (state, action) => {
                state.jobLoading = false;
                // state.jobBarcodeDashBoardError = true;
            })
            .addCase(getEventStagesHistory.pending, (state, action) => {
                state.jobLoading = true;
            })
            .addCase(getEventStagesHistory.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.eventStagesHistoryData = action.payload;
            })
            .addCase(getEventStagesHistory.rejected, (state, action) => {
                state.jobLoading = false;
            }).addCase(getAllBoxes.pending, (state, action) => {
                state.jobLoading = true;
            })
            .addCase(getAllBoxes.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.getAllBoxesData = action.payload;
            })
            .addCase(getAllBoxes.rejected, (state, action) => {
                state.jobLoading = false;
            })
            .addCase(getJobInspectionReport.pending, (state, action) => {
                state.jobLoading = true;
            })
            .addCase(getJobInspectionReport.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.getJobInspectionReportData = action.payload;
            })
            .addCase(getJobInspectionReport.rejected, (state, action) => {
                state.jobLoading = false;
            })
            .addCase(getEventBoxes.pending, (state, action) => {
                state.jobLoading = true;
            })
            .addCase(getEventBoxes.fulfilled, (state, action) => {
                state.jobLoading = false;
                state.getEventBoxesData = action.payload;
            })
            .addCase(getEventBoxes.rejected, (state, action) => {
                state.jobLoading = false;
            })



    },
});

// Export actions and selectors
export const { resetSuccessFlag, resetAllocationData, clearUserJobEventData, clearUserCompletedData, clearAdminJobEventData } = jobSlice.actions;
export const jobSelector = (state) => state[namespace];
export default jobSlice.reducer;
